import React from 'react';
import {Modal,
ModalHeader,
ModalBody} from 'reactstrap'

let array=[
		{key : 1,no : 1, subscription:'Level 1 plan + Extra Plan', date : '11/11/2018', amount : '$101.5'}, 
		{key : 2,no : 2, subscription:'Level 1 plan + Extra Plan', date : '11/12/2018', amount : '$101.5'},
		{key : 3,no : 3, subscription:'Level 1 plan + Extra Plan', date : '11/01/2019', amount : '$101.5'},
		{key : 4,no : 4, subscription:'Level 1 plan + Extra Plan', date : '11/02/2019', amount : '$101.5'},
		{key : 5,no : 5, subscription:'Level 1 plan + Extra Plan', date : '11/03/2019', amount : '$101.5'},
		{key : 6,no : 6, subscription:'Level 1 plan + Extra Plan', date : '11/04/2019', amount : '$101.5'},
		{key : 7,no : 7, subscription:'Level 1 plan + Extra Plan', date : '11/05/2019', amount : '$101.5'},
	]

class modalPlan extends React.Component {
	constructor(props){
    super(props)
		this.state ={
			
		}
	}

	render() {
		return(
			<Modal isOpen={this.props.ModalState} toggle={() => this.props.CloseModal()} className="modal-lg">
				<ModalHeader toggle={() => this.props.CloseModal()}>View Payment History</ModalHeader>
				<ModalBody>
					<div className="row">
						<div className="col-md-12 m-top-15">
							<table className="table table-striped table-hover">
								<thead>
									<tr>
										<th width='5%' className="text-center">No</th>
										<th width='25%'>Subscription</th>
										<th width='20%'>Date</th>
										<th width='20%'>Amount</th>
										<th width='30%' className="text-center">Options</th>
									</tr>
								</thead>
								<tbody>
									{array.map(function(element) {
										return(
											<tr key={element.key}>
												<td>{element.no}</td>
												<td>{element.subscription}</td>
												<td>{element.date}</td>
												<td>{element.amount}</td>
												<td>
													<div className="text-right">
								            <button id="printInvoice" className="btn btn-info btn-sm"><i className="fa fa-print"></i> Print</button>
								            <button className="btn btn-info btn-sm"><i className="fa fa-file-pdf-o"></i> Export as PDF</button>
									        </div>
												</td>
											</tr>
										)
									})}
								</tbody>
							</table>
						</div>
					</div>
				</ModalBody>
			</Modal>
		)
	}
}

export default modalPlan;



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/billing/ModalHistory.js